import moment, { Moment } from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DatePicker as MUIDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import FieldError from "../fieldError";

const ISO_DATE = "YYYY-MM-DD";

interface DatePickerProps {
  /** ISO "YYYY-MM-DD", or empty for no date. */
  value: string;
  onChange: (date: string) => void;
  minDate?: string;
  error?: string;
  disabled?: boolean;
}

/** Calendar date input that reads and writes ISO date strings. */
const DatePicker: React.FC<DatePickerProps> = ({
  value,
  onChange,
  minDate,
  error,
  disabled = false,
}) => (
  <LocalizationProvider dateAdapter={AdapterMoment}>
    <MUIDatePicker
      value={value ? moment(value, ISO_DATE) : null}
      onChange={(m) => {
        const date = m as Moment | null;
        onChange(date && date.isValid() ? date.format(ISO_DATE) : "");
      }}
      minDate={minDate ? moment(minDate, ISO_DATE) : undefined}
      disabled={disabled}
      format="MMM D, YYYY"
      slotProps={{
        textField: { size: "small", fullWidth: true, error: Boolean(error) },
      }}
    />
    <FieldError error={error} />
  </LocalizationProvider>
);

export default DatePicker;
